export const SET_ACTIVE_CONVERSATION = 'SET_ACTIVE_CONVERSATION'
export const CREATE_MESSAGE = 'CREATE_MESSAGE'
export const HIDE_CONVERSATION_WINDOW = 'HIDE_CONVERSATION_WINDOW'
export const REMOVE_CONVERSATIONS = 'REMOVE_CONVERSATIONS'